import React, { Component } from "react";
import Carousel from "react-multi-carousel";
import Image from "../../../base/features/micro/Image";
import { Redirect } from "react-router-dom";
import actionHandler from "../../../base/utils/action_handler";
import { isDesktop } from "react-device-detect";

class DynamicAds extends Component {
  constructor(props) {
    super(props);
    this.state = {
      responsive: {
        superLargeDesktop: {
          breakpoint: { max: 4000, min: 3000 },
          items: 1,
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 1,
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1,
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
        },
      },
    };
  }

  render() {
    return (
      <div className="row mx-0 px-4" dir="ltr">
        {this.state.actionUrl && <Redirect push to={this.state.actionUrl} />}
        <div
          className={`col-12 px-0 mb-2 fw-bold`}
          dir="rtl"
          style={{
            color: this.props.view.title_color,
            fontSize: this.props.view.title_size + "px",
          }}
        >
          {this.props.view.title}
        </div>
        <div className="col-12 px-0">
          <Carousel
            className=""
            autoPlay={false}
            responsive={this.state.responsive}
            showDots={this.props.view.items.length === 1 ? false : true}
            infinite={this.props.view.items.length === 1 ? false : true}
            draggable={true}
            swipeable={true}
            keyBoardControl={true}
            arrows={false}
            sliderClass="h-100 mb-2"
            containerClass="carousel-container"
            dotListClass="custom-dot-list-style"
          >
            {this.props.view.items?.map((item, i) => (
              <div
                className="col-12 px-0 py-2"
                onClick={() =>
                  item.action &&
                  this.setState({
                    actionUrl: actionHandler(
                      item.action,
                      item.action_data,
                      item.title
                    ),
                  })
                }
              >
                <Image
                  imageHeight={isDesktop ? "160" : "125"}
                  extraClassName={"p-0 img-contain"}
                  imgClassName={"mb-4 w-100 rounded14 img-cover"}
                  imageUri={item.media && item.media.file}
                />
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    );
  }
}

export default DynamicAds;
